import type {MaybeRef} from 'vue';

export const spaceKey = 'space';

export function spaceStructureQueryKey(
    userId: MaybeRef<string | null>,
    effectiveBookingForId: MaybeRef<string | null>
) {
    return [spaceKey, 'structure', userId, effectiveBookingForId] as const;
}

export function characteristicsQueryKey(locationId: MaybeRef<string | null>) {
    return [spaceKey, 'characteristics', locationId] as const;
}
